// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-footer {
  background: var(--ion-color-primary);
}

ion-spinner {
  height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/ble-devices/ble-devices.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,YAAA;AACF","sourcesContent":["ion-footer {\r\n  background: var(--ion-color-primary);\r\n}\r\n\r\nion-spinner {\r\n  height: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
